import { render, staticRenderFns } from "./Jungle.vue?vue&type=template&id=b5398400&scoped=true"
import script from "./Jungle.vue?vue&type=script&lang=js"
export * from "./Jungle.vue?vue&type=script&lang=js"
import style0 from "./Jungle.vue?vue&type=style&index=0&id=b5398400&prod&scoped=true&lang=scss"
import style1 from "./Jungle.vue?vue&type=style&index=1&id=b5398400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5398400",
  null
  
)

export default component.exports